// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/verbaNaDica.ts

/**
 * Quais números da verba a dica do novo custo pode exibir: a cadeia inteira, a cadeia zerada ou
 * nada. Chave ausente é "esta linha não fala de verba"; chave nula é "não há acordo".
 */

import type { CampoDaVerba } from './verbaDeSellIn';

export type NumerosDaVerbaNaDica = {
  sellinAllowance?: number | null;
  effectiveNetCost?: number | null;
  sellinAllowanceToSupplier?: number | null;
};

/** O custo líquido efetivo vem da LINHA: quem grava a verba tem de escrevê-lo de volta nela. */
export const numerosDaVerbaParaADica = (campo: CampoDaVerba | undefined, effectiveNetCost: number | null | undefined): NumerosDaVerbaNaDica => {
  if (!campo) return {};

  // Sem acordo, `sellinAllowanceToSupplier` carrega a SUGESTÃO convertida, e não entra na cadeia.
  if (campo.valor === null || campo.valor === 0) {
    return { sellinAllowance: null, effectiveNetCost };
  }

  // Verba ao fornecedor vazia: o número do motor é do valor ANTERIOR, não deste.
  if (campo.verbaAoFornecedor === null) return {};

  return {
    sellinAllowance: campo.valor,
    effectiveNetCost,
    sellinAllowanceToSupplier: campo.verbaAoFornecedor,
  };
};
